import { createAction } from 'redux-actions';

export const updateGuestFileSearchQuery = createAction(
  'UPDATE_GUEST_FILE_SEARCH_QUERY'
);

export const resetGuestFileSearchQuery = createAction(
  'RESET_GUEST_FILE_SEARCH_QUERY'
);
